/*
* @TagTable.vue
* @Description 基站管理组件
* @Author
* @Date 2021/6/28
*/
<template>
    <div class="_table-item-box view-page-box" style="padding: 10px;">
        <section style="height: 100%;">
            <!-- 表格 -->
            <el-table :data="videoInfos"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      style="width: 100%; "
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column label="视频编号" min-width="80px" :sortable="filters.sortable" prop="number" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.number">{{scope.row.number}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="视频名称" min-width="80px" :sortable="filters.sortable" prop="number" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.diskChannelName">{{scope.row.diskChannelName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="读取方式" min-width="80px" :sortable="filters.sortable" prop="read_mode" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.readModeName">{{scope.row.readModeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" min-width="60px" :sortable="filters.sortable" prop="brand" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.brandName">{{scope.row.brandName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="IP" min-width="100px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="(scope.row.readMode==1?scope.row.diskIp:scope.row.cameraIp) + (scope.row.pingIp?'通过':'不通')"><i class="el-icon-warning" v-if="!scope.row.pingIp" :title="(scope.row.readMode==1?scope.row.diskIp:scope.row.cameraIp) + ' 连不通'" style="color: #e99e2e;"></i>{{scope.row.readMode==1?scope.row.diskIp:scope.row.cameraIp}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="通道号/IP" min-width="100px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.readMode==1?('通道号：' + scope.row.diskChannelNo):('--')"><i class="el-icon-warning" v-if="!scope.row.pingIp2" :title="scope.row.cameraIp + ' 连不通'" style="color: #e99e2e;"></i>{{scope.row.readMode==1?(scope.row.diskChannelNo + (scope.row.cameraIp==''?'': ('/' + scope.row.cameraIp))):'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="码流类型" min-width="60px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.subtypeName">{{scope.row.subtypeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="编码格式" min-width="60px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.codecName">{{scope.row.codecName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联地图" min-width="100px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.mapName">{{scope.row.mapName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="150px">
                    <template slot-scope="scope" >
                      <span class="el-icon-edit" @click="()=>{editRow(scope.row, scope.$index)}" trigger="click" style="margin-right: 10px;cursor: pointer;"> 编辑</span>
                      <el-switch
                          size="mini"
                          class="switchStyle"
                          v-model="scope.row.isOpen"
                          :active-value="1"
                          :inactive-value="0"
                          active-color="#00A854"
                          active-text="启用"
                          inactive-color="gray"
                          inactive-text="禁用"
                          @change="changeState(scope.row,scope.$index)">
                      </el-switch>
                        <span class="el-icon-video-play" @click="()=>{testrun(scope.row, scope.$index)}" trigger="click" style="margin-right: 10px;cursor: pointer;" v-if="scope.row.realAddr && scope.row.pingIp && scope.row.pingIp2"> 试运行</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
                style="margin-bottom: 10px;"
            />

            <!--查询工具条-->
            <el-col style="text-align: left;">
            <el-form :inline="true" :model="filters" ref="filters">
              <el-form-item>查询条件：</el-form-item>
              <el-form-item prop="mapId">
                <el-select v-model="filters.mapId" placeholder="关联地图" clearable @change="researchVideo">
                  <el-option v-for="(item,key) in orgMaps" :key="key" :label="item.mapName" :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="readMode">
                <el-select v-model="filters.readMode" placeholder="请选择读取方式" clearable @change="researchVideo">
                  <el-option v-for="item in filters.readModes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="brand">
                <el-select v-model="filters.brand" placeholder="请选择品牌" clearable @change="researchVideo">
                  <el-option v-for="item in filters.brands" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="brand">
                <el-select v-model="filters.isOpen" placeholder="请选择状态" clearable @change="researchVideo">
                  <el-option v-for="item in filters.status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="keywords">
                <el-input v-model="filters.keywords" placeholder="请输入编号/IP" clearable @keyup.enter.native="researchVideo" :style="{width: '240px'}">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="researchVideo"></i>
                </el-input>
              </el-form-item>
              <el-form-item style="position: absolute;top: 9px;right: 20px;margin: 0px;z-index: 3;">
                <el-dropdown split-button type="primary"  @click="add" trigger="click" size="mini">
                  <i class="el-icon-circle-plus-outline"></i> 新增视频配置
                  <el-dropdown-menu slot="dropdown" trigger="click">
                    <el-dropdown-item  icon="el-icon-delete" @click.native="remove">批量删除</el-dropdown-item>
                    <el-dropdown-item  icon="el-icon-tickets" @click.native="download">模板下载</el-dropdown-item>
                    <el-dropdown-item>
                      <el-upload
                          ref="uploadTag"
                          accept=".xlsx,.xls"
                          :auto-upload="true"
                          :show-file-list="false"
                          :before-upload="beforeUpload"
                          :on-success="uploadSuccess"
                          :on-error="uploadError"
                          :action="upload.uploadUrl"
                          :headers="upload.myHeaders"
                      >
                        <i class="el-icon-upload2"></i>批量上传
                      </el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item  icon="el-icon-download" @click.native="searchExportData">批量导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-col>

            <!-- ======================= 导出所需数据 =============================== -->
            <el-table :data="exportVideoInfos"  id="out-table" stripe  style="display: none;" class="table">
            <el-table-column label="视频编号" min-width="80px">
              <template slot-scope="scope">
                {{scope.row.number}}
              </template>
            </el-table-column>
            <el-table-column label="视频名称" min-width="80px">
              <template slot-scope="scope">
                {{scope.row.diskChannelName}}
              </template>
            </el-table-column>
            <el-table-column label="读取方式" min-width="80px">
              <template slot-scope="scope">
                {{scope.row.readModeName}}
              </template>
            </el-table-column>
            <el-table-column label="品牌" min-width="60px">
              <template slot-scope="scope">
                {{scope.row.brandName}}
              </template>
            </el-table-column>
            <el-table-column label="IP" min-width="80px">
              <template slot-scope="scope">
                {{scope.row.readMode==1?scope.row.diskIp:scope.row.cameraIp}}
              </template>
            </el-table-column>
            <el-table-column label="通道号" min-width="80px">
              <template slot-scope="scope">
                {{scope.row.readMode==1?scope.row.diskChannelNo:'--'}}
              </template>
            </el-table-column>
            <el-table-column label="码流类型" min-width="60px">
              <template slot-scope="scope">
                {{scope.row.subtypeName}}
              </template>
            </el-table-column>
            <el-table-column label="编码格式" min-width="60px">
              <template slot-scope="scope">
                {{scope.row.codecName}}
              </template>
            </el-table-column>
            <el-table-column label="关联地图" min-width="100px">
              <template slot-scope="scope">
                {{scope.row.mapName}}
              </template>
            </el-table-column>
          </el-table>

            <!-- 新增视频 -->
            <VideoDialog ref="videoDialog"
                         :subtypes="filters.subtypes"
                         :codecs="filters.codecs"
                         :brands="filters.brands"
                         :read-modes="filters.readModes"
                         :maps = "orgMaps"
                         @reSearch = "setRow"
            />

            <!-- Excel上传 -->
            <UploadVideoDialog ref="uploadVideoDialog"
                          :showSerialNumber="upload.showSerialNumber"
                          :uploadUrl="upload.saveUrl"
                          :previewTitle="upload.previewTitle"
                          :previewData="upload.previewData"
                          @reSearch = "researchVideo"/>

            <!-- webSoket jkkcPlayer -->
            <SubJkkcPlayer ref="wsPlayer" v-if="wsPlayerFilter.creatWsFlag && playerMode == 1"
              :wsOnopen="wsPlayerFilter.wsOnopen"
              :wsOnmessage="wsPlayerFilter.wsOnmessage"
            />

        </section>
    </div>

</template>

<script>
    // 公共变量
	import GlobalVariable from '@/global/global-variable';
	// 公用函数
	import GlobalFun from '@/global/global-function';
    
    // 视频接口
    import ApiOam from '@/request/api-oam'
    // 视频接口
    import ApiVideo from '@/request/api-video'
    // 视频接口
    import ApiCommon from '@/request/api-common'
    
    // jkkcPlayer 组件
    import SubJkkcPlayer from '@/components/SubJkkcPlayer'
    // 弹框组件
    import VideoDialog from './VideoDialog'
    // 上传组件
    import UploadVideoDialog from './UploadVideoDialog'
    // 上传组件
    import Pagination from '@/components/Pagination'
    // 树
    import TreeSelect from '@/components/TreeSingleSelect'

    export default {
        name: "VideoTable",
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/28
         */
        components: {
            // 视频弹出层组件
            VideoDialog,
            // 上传组件
            UploadVideoDialog,
            // 选择树
            TreeSelect,
            // jkkcPlayer 组件
            SubJkkcPlayer,
            Pagination
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/28
         */
        data() {
            return {
                /**
                 * @Des 查询条件属性
                 * @Auth
                 * @Date 2021/6/28
                 */
                filters: {
                    readMode: '',
                    brand: '',
                    keywords: '',
                    isOpen: '',
                    orderBy: {
                        "number": "asc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom',
                    mapId: '',
                    readModes: [{
                        id: 1,
                        name: '硬盘录像机'
                    },{
                        id: 2,
                        name: '摄像头'
                    }],
                    brands: [{
                        id: 1,
                        name: '海康'
                    },{
                        id: 2,
                        name: '宇视'
                    },{
                        id: 3,
                        name: '大华'
                    }],
                    subtypes: [{
                        id: 1,
                        name: '主码流'
                    },{
                        id: 2,
                        name: '子码流'
                    }],
                    codecs: [{
                        id: 1,
                        name: 'H.264'
                    },{
                        id: 2,
                        name: 'H.265'
                    }],
                    status: [{
                        id: 1,
                        name: '开启'
                    },{
                        id: 0,
                        name: '禁用'
                    },]
                },
                /**
                 * @Des 分页组件
                 * @Auth
                 * @Date 2021/6/28
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 20,
                    currentPage: 1
                },
                // 组织结构 list
                orgList: [],
                // 地图 总list
                orgMaps: {},
                // 基站集合
                videoInfos:[],
                // 导出基站集合
                exportVideoInfos: [],

                /**
	             * @Des wsPlayerFilter
	             * @Auth
	             * @Date 2021/9/2
	             */
                wsPlayerFilter: {
                	// 创建 ws flag
                	creatWsFlag: true,
                	// 连接已打开
                	wsOnopen: null,
                	// 连接发生错误
                	wsOnerror: this.wsOnerrorPlayer,
                	// 连接关闭
                	wsOnclose: this.wsOnclosePlayer,
                	// 数据推送
                	wsOnmessage: this.wsOnmessagePlayer,
                },
                // wsPlayer elem
                palyerSub: this.$refs.wsPlayer,
				// 播放器模式
				playerMode: GlobalVariable.VIDEO_PLAYER_MODE,// 1、VLCPlayer 2、WebrtcPlayer
                /**
                 * @Des 上传属性
                 * @Auth
                 * @Date 2021/4/30
                 */
                upload:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    previewTitle:[],
                    previewData:[],
                    uploadUrl: ApiVideo.uploadVideoFileApi + '?projectId=' + this.$store.state.currentProjectId,
                    saveUrl: ApiVideo.addVideoApi,
                    showSerialNumber: false
                },
                /**
                 * 上传数据样式修改
                 * */
                surroundSpan(value) {
                    return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
                },

            }
        },
        computed: {
        },
        /**
         * @Des 加载完成
         * @Auth
         * @Date 2021/6/28
         */
        mounted(){
            // wsPlayer elem
            this.palyerSub = this.$refs.wsPlayer;
            this.searchMap();
            
            // 监听页面
			window.addEventListener('beforeunload', this.closeVideoWin, false);
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 2021/9/26
         */
        beforeDestroy() {
        	// 关闭视频弹窗
        	this.closeVideoWin();
        	
        	// 监听页面
			window.removeEventListener('beforeunload', this.closeVideoWin, false);
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/28
         */
        methods: {
            /**
             * @Des 选择值改变
             * @Auth
             * @Date 2021/6/4
             */
            searchMap(val){
                this.$request.postJsonRequest(ApiOam.Find_Map_By_ProjectId_Uri, {
                  projectId: this.$store.state.currentProjectId,
                }).then(result => {
                  if(result.code == 0 && result.data){
                      result.data.forEach((item, index) => {
                        this.orgMaps[item.mapId] = item;
                      })
                  }
                  // 改变总数
                  this.searchVideo();
                }).catch(error => {
                  console.error('查询地图异常', ApiOam.Find_Map_By_ProjectId_Uri, error);
                })
            },
            /**
             * 重新搜索
             * */
            researchVideo(){
                this.pagination.startNum = 0;
                this.pagination.total = 0;
                this.pagination.currentPage = 1;
                this.searchVideo();
            },
            /**
             * @Des 查询视频
             * @Auth
             * @Date 2021/6/28
             */
            searchVideo() {
                if(this.locked) return false;
                this.locked = true;

                this.$request.postJsonRequest(ApiVideo.searchVideoApi, {
                    mapId: this.filters.mapId,
                    readMode: this.filters.readMode,
                    brand: this.filters.brand,
                    isOpen: this.filters.isOpen,
                    keywords: this.filters.keywords,
                    orderBy: this.filters.orderBy,
                    projectId: this.$store.state.currentProjectId,
                    offset: this.pagination.startNum,
                    limit: this.pagination.limit,
                    total: this.pagination.total
                }).then(result => {
                    this.videoInfos = [];
                    this.pagination.total = result.total;
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            row.readModeName = '';
                            this.filters.readModes.forEach((r, i) => {
                                if(r.id == row.readMode){
                                    row.readModeName = r.name;
                                    this.filters.readModes.forEach.break=new Error("StopReadModes");
                                }
                            })
                            row.brandName = '';
                            this.filters.brands.forEach((r, i) => {
                                if(r.id == row.brand){
                                    row.brandName = r.name;
                                    this.filters.brands.forEach.break=new Error("StopBrands");
                                }
                            })
                            row.subtypeName = '';
                            this.filters.subtypes.forEach((r, i) => {
                                if(r.id == row.subtype){
                                    row.subtypeName = r.name;
                                    this.filters.subtypes.forEach.break=new Error("StopSubtypes");
                                }
                            })
                            row.codecName = '';
                            this.filters.codecs.forEach((r, i) => {
                                if(r.id == row.codec){
                                    row.codecName = r.name;
                                    this.filters.codecs.forEach.break=new Error("StopCodecs");
                                }
                            })
                            if(row.mapId){
                                row.mapName = this.orgMaps[row.mapId].mapName;
                            }
                            row.pingIp = true;
                            row.pingIp2 = true;
                            this.videoInfos.push(row);
                        })
                        // 检测ip是否通
                        this.checkIpConnect();
                    }
                    this.locked = false;
                }).catch(error => {
                	this.locked = false;
                	console.error('查询摄像头异常', ApiVideo.searchVideoApi, error);
                })
            },
            /**
             * @Des 检测ip是否通
             * @Auth
             * @Date 2021/7/3
             */
            checkIpConnect(){
                if(this.videoInfos.length > 0){
                    this.videoInfos.forEach((row, index) => {
                        this.$request.postJsonRequest(ApiCommon.checkIpConnect, {
                            ip: row.readMode==1?row.diskIp:row.cameraIp,
                            timeout: 1500
                        }).then(result => {
                            if(result.code == 0){
                                this.videoInfos[index].pingIp = true;
                            }else{
                                this.videoInfos[index].pingIp = false;
                                row.isOpen = 0;
                                this.changeState(row, index);
                            }
                        }).catch(error => {
                            this.videoInfos[index].pingIp = false;
                            row.isOpen = 0;
                            this.changeState(row, index);
                            console.log('检索IP通道异常', ApiCommon.checkIpConnect, error);
                        })
                        if(row.readMode == 1 && row.cameraIp != ''){
                          this.$request.postJsonRequest(ApiCommon.checkIpConnect, {
                            ip: row.cameraIp,
                            timeout: 1500
                          }).then(result => {
                            if(result.code == 0){
                              this.videoInfos[index].pingIp2 = true;
                            }else{
                              this.videoInfos[index].pingIp2 = false;
                              row.isOpen = 0;
                              this.changeState(row, index);
                            }
                          }).catch(error => {
                            this.videoInfos[index].pingIp2 = false;
                            row.isOpen = 0;
                            this.changeState(row, index);
                            console.log('检索IP通道异常', ApiCommon.checkIpConnect, error);
                          })
                        }
                    })
                }
            },

            /**
             * @Des 查询导出数据
             * @Auth
             * @Date 2021/7/3
             */
            searchExportData() {
                if(this.locked) return false;
                this.locked = true;

                this.$request.postJsonRequest(ApiVideo.exportVideoApi, {
                    mapId: this.filters.mapId,
                    readMode: this.filters.readMode,
                    brand: this.filters.brand,
                    keywords: this.filters.keywords,
                    orderBy: this.filters.orderBy,
                    projectId: this.$store.state.currentProjectId,
                }).then(result => {
                    this.exportVideoInfos = [];
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            row.readModeName = '';
                            this.filters.readModes.forEach((r, i) => {
                                if(r.id == row.readMode){
                                    row.readModeName = r.name;
                                    this.filters.readModes.forEach.break=new Error("StopReadModes");
                                }
                            })
                            row.brandName = '';
                            this.filters.brands.forEach((r, i) => {
                                if(r.id == row.brand){
                                    row.brandName = r.name;
                                    this.filters.brands.forEach.break=new Error("StopBrands");
                                }
                            })
                            row.subtypeName = '';
                            this.filters.subtypes.forEach((r, i) => {
                                if(r.id == row.subtype){
                                    row.subtypeName = r.name;
                                    this.filters.subtypes.forEach.break=new Error("StopSubtypes");
                                }
                            })
                            row.codecName = '';
                            this.filters.codecs.forEach((r, i) => {
                                if(r.id == row.codec){
                                    row.codecName = r.name;
                                    this.filters.codecs.forEach.break=new Error("StopCodecs");
                                }
                            })
                            this.exportVideoInfos.push(row);
                        })
                    }
                    this.$nextTick(() => {
                        if(this.exportVideoInfos.length == 0){
                            this.$message({
                                message: '查询无数据，无法导出',
                                type: 'warning',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.locked = false;
                            return false;
                        }
                        GlobalFun.exportExcel(document.querySelector("#out-table"),'视频信息.xlsx');
                        this.locked = false;
                    });
                }).catch(error => {
                	this.locked = false;
                	console.error('导出摄像头异常', ApiVideo.exportVideoApi, error);
                })
                if(this.locked) return false;
                this.locked = true;

            },
            /**
             * @Des 添加视频
             * @Auth
             * @Date 2021/6/28
             */
            add() {
                this.$refs.videoDialog.openDialog(false, '新增摄像头');
            },
            /**
             * @Des 编辑标签
             * @Auth
             * @Date 2021/6/28
             */
            editRow(row, index) {
                this.$refs.videoDialog.openDialog(true, '编辑摄像头', row, index);
            },
            /**
             * @Des 编辑标签
             * @Auth
             * @Date 2021/9/26
             */
            testrun(row, index) {
                /*if(!row.pingIp){
                    this.$message({
                        message: (row.readMode==1?row.diskIp:row.cameraIp) + ' 无法连通，请检查本机IP是否在同一网段，或者摄像头已掉线',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }*/
                //console.log(row, index);
                var _url = row.realAddr;
                //var _url = 'rtsp://admin:z455152781@192.168.0.190:554/Streaming/Channels/201';
                var _title = '视频 ' + row.number;
                // 视频 参数
                var _vOption = {
                  title: _title,
                  status: 1,
                  url: _url
                };
                //console.log({row, _vOption});
                
                // Webrtc Player
				if (this.playerMode == 2) {
					_vOption['title'] = row.diskChannelName;
					_vOption['vId'] = row.number;
					_vOption['vInfo'] = Object.assign({}, row, {vId: row.number,rtsp: row.realAddr});
				}
                
                //发送数据 视频状态
                this.sendVideoStatePlayer( _vOption,  401,  '打开视频');
            },
            /**
             * @Des 关闭视频弹窗
             * @Auth
             * @Date 2021/9/26
             */
            closeVideoWin() {
              // 视频 参数
              var _vOption = {
                title: '',
                status: 4,
                rate: 1,
                url: ''
              };
              //发送数据 视频状态
              this.sendVideoStatePlayer( _vOption,  401,  '关闭视频');
            },
			/**
			 * @Des 发送数据 视频状态
			 * @Auth
			 * @Date 2021/9/26
			 */
			sendVideoStatePlayer( _option,  _code,  _msg) {
				if(this.playerMode == 1 && this.$checkEmpty(this.palyerSub)) {
					return false;
				}
				
				var jsonData = {
					code: _code,
					data: {
						title: _option.title,
						rate: 1,
						status: _option.status,
						url: _option.url,
						username: '',
						vId: _option.vId,
						vInfo: _option.vInfo
					},
					msg: _msg
				};
				
				// VLC Player
				if (this.playerMode == 1) {
					var jsonStr = JSON.stringify(jsonData);
					(typeof this.palyerSub.send == 'function') && this.palyerSub.send(jsonStr);
				} else if (this.playerMode == 2) {
					// 发布消息 视频播放器
					this.$pubsub.publish('ChangePlayerDate', Object.assign({}, jsonData));
				}
			},
			
            /**
             * 启用/禁用
             * */
            changeState(row, index){
                this.$request.postJsonRequest(ApiVideo.updateStatusApi, {
                    cameraId: row.cameraId,
                    isOpen: row.isOpen,
                    projectId: this.$store.state.currentProjectId
                }).then(result => {
                    //console.log(result)
                    /*if (result.code == 0) {
                        this.$message({
                            message: row.isOpen==1?'启用成功！':'禁用成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }*/
                    this.locked = false;
                }).catch(error => {
                	this.locked = false;
                	console.error('启用/禁用 摄像头异常', ApiVideo.updateStatusApi, error);
                })
            },
            /**
             * @Des 批量删除
             * @Auth
             * @Date 2021/7/2
             */
            remove() {
                if(this.locked) return false;
                this.locked = true;

                const ids = [];

                // 获取选中的行数据
                let selection = this.$refs.multipleTable.selection;
                if (0 != selection.length) {

                    selection.forEach((row, index) => {
                        ids.push(row.cameraId);
                    })
                } else {
                    this.$message({
                        type: 'info',
                        message: '请选择数据',
                        dangerouslyUseHTMLString: true
                    });
                    this.locked = false;
                    return;
                }

                this.$confirm('确定要批量删除摄像头吗？','提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.$request.postJsonRequest(ApiVideo.deleteBatchVideoApi, {
                        cameraIds: ids,
                        projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '批量删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.locked = false;
                        this.researchVideo();
                    }).catch(error => {
                    	this.locked = false;
                    	console.error('批量删除摄像头异常', ApiVideo.deleteBatchVideoApi, error);
                    })
                }).catch(() => {
                    this.locked = false;
                })
            },

            setRow(row){
                if(row && row.index != -1){
                    this.searchVideo();

                    // 合并数据
                    this.$set(this.videoInfos, row.index, Object.assign({}, row));
                }else{
                    this.researchVideo();
                }
            },

            /**
             * @Des 删除基站
             * @Auth
             * @Date 2021/6/28
             */
            removeRow(row, index) {
                if(this.locked) return false;
                this.locked = true;

                this.$confirm('确定要删除摄像头：' + row.bsId + '吗？','提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.$request.postJsonRequest(ApiVideo.deleteVideoApi, {
                        cameraId: row.cameraId,
                        projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.researchVideo();
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.locked = false;
                    }).catch(error => {
                    	this.locked = false;
                    	console.error('删除摄像头异常', ApiVideo.deleteVideoApi, error);
                    })
                }).catch(() => {
                    this.locked = false;
                })
            },
            /**
             * 是否选择
             * */
            checkSelectable(row){
                return true;
            },
            /**
             * @Des 下载模板
             * @Auth
             * @Date 2021/6/4
             */
            download(){
                // 下载模板
                // 文件名
                let fileName = '视频上传模板.xlsx';
                // 资源文件下载 至本地
                GlobalFun.downloadFile(ApiVideo.videoUploadModel, fileName);
            },
            /**
             * @Des 上传之前的处理
             * @Auth
             * @Date 2021/4/30
             */
            beforeUpload(file){
                // 上传之前
                // console.log(file)
                this.upload.previewTitle = [];
                this.upload.previewData = [];
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(extension !== 'xlsx') {
                    this.$message.warning('只能上传后缀是.xlsx的文件');
                }
                if(size > 10) {
                    this.$message.warning('文件大小不得超过10M');
                }
            },

            /**
             * @Des 上传成功后的处理
             * @Auth
             * @Date 2021/4/30
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                // console.log(res, file, fileList);
                // console.log(this.upload.fileType)
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)
                    // 显示标签列表信息
                    this.upload.previewTitle.push({
                        label: '品牌',
                        prop: 'brandName',
                        width: '60px'
                    });
                    this.upload.previewTitle.push({
                        label: '读取方式',
                        prop: 'readModeName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: 'IP',
                        prop: 'ip',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '账号',
                        prop: 'user',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '密码',
                        prop: 'password',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '编号',
                        prop: 'number',
                        width: '60px'
                    });
                    this.upload.previewTitle.push({
                        label: '名称',
                        prop: 'diskChannelName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '码流类型',
                        prop: 'subtypeName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '编码格式',
                        prop: 'codecName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '区域',
                        prop: 'areaName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '地图',
                        prop: 'mapName',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '坐标',
                        prop: 'points',
                        width: '120px'
                    });
                    this.upload.previewTitle.push({
                        label: '信息',
                        prop: 'message',
                        width: '120px'
                    })

                    res.data.forEach((row, index) => {
                        row.readModeName = '';
                        this.filters.readModes.forEach((r, i) => {
                            if(r.id == row.readMode){
                                row.readModeName = r.name;
                                this.filters.readModes.forEach.break=new Error("StopReadModes");
                            }
                        })
                        row.brandName = '';
                        this.filters.brands.forEach((r, i) => {
                            if(r.id == row.brand){
                                row.brandName = r.name;
                                this.filters.brands.forEach.break=new Error("StopBrands");
                            }
                        })
                        row.subtypeName = '';
                        this.filters.subtypes.forEach((r, i) => {
                            if(r.id == row.subtype){
                                row.subtypeName = r.name;
                                this.filters.subtypes.forEach.break=new Error("StopSubtypes");
                            }
                        })
                        row.codecName = '';
                        this.filters.codecs.forEach((r, i) => {
                            if(r.id == row.codec){
                                row.codecName = r.name;
                                this.filters.codecs.forEach.break=new Error("StopCodecs");
                            }
                        })
                        let _row = {
                            brand: row.brand,
                            brandName: row.brandName,
                            readMode: row.readMode,
                            readModeName: row.readModeName,
                            diskIp: row.diskIp,
                            diskAccount: row.diskAccount,
                            diskPassword: row.diskPassword,
                            cameraIp: row.cameraIp,
                            cameraAccount: row.cameraAccount,
                            cameraPassword: row.cameraPassword,
                            ip: row.readMode==1?row.diskIp:row.cameraIp,
                            user: row.readMode==1?row.diskAccount:row.cameraAccount,
                            password: row.readMode==1?row.diskPassword:row.cameraPassword,
                            number: row.number,
                            diskChannelName: row.diskChannelName,
                            subtype: row.subtype,
                            subtypeName: row.subtypeName,
                            codec: row.codec,
                            codecName: row.codecName,
                            diskChannelNo: row.diskChannelNo,
                            pointX: row.pointX,
                            pointY: row.pointY,
                            pointZ: row.pointZ,
                            areaName: row.areaName,
                            mapId: row.mapId,
                            mapName: row.mapName,
                            points: this.$checkEmpty(row.mapId)?'':[this.$checkEmpty(row.pointX)?'':row.pointX, this.$checkEmpty(row.pointX)?'':row.pointX, this.$checkEmpty(row.pointZ)?'':row.pointZ],
                            code: row.code,
                            message: row.message,
                            disabled: row.code==0?false:true,
                            checked: row.code==0?true:false,
                        }

                        let _row_ = {};
                        for (let i in _row) {
                            // 外围添加 span
                            _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                        };

                        this.upload.previewData.push(Object.assign({}, _row, _row_));
                    })

                    if(this.upload.previewData.length > 0){
                        //弹出预览
                        this.$refs.uploadVideoDialog.openDialog("视频上传预览", "确定上传");
                    }
                    // console.log(res.data)
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                }
            },

            /**
             * @Des 上传失败后的处理
             * @Auth
             * @Date 2021/4/30
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order == null){
                    this.filters.orderBy["number"] = "asc";
                }else{
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                    if(this.filters.orderBy["number"] == null){
                        this.filters.orderBy["number"] = "asc";
                    }
                }
                this.researchVideo();
            },
            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/30
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/30
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
            },
        },
        /**
         * @Des 初始化加载处理
         * @Auth
         * @Date 2021/6/28
         */
        created(){
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	.el-table {
		height: calc(100% - 110px);
	}
	.el-col {
		.el-form-item {
			margin-bottom: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/VideoTable.vue